import * as React from "react";
import EdButton from "../../../generic/edButton";
import "../../../../assets/scss/components/toc/orderBook/generic/obNoDataFound.scss";
export interface ITocNoDataProps {
	data: Array<Array<any>>; // data to be filtered
	callBackMeth: (filteredData: Array<any>) => void; // function to be called on clicking of checkbox
	errMsg?: React.ReactNode;
	showClrBtn?: boolean;
}

const TocNoData: React.FC<ITocNoDataProps> = (props) => {
	return (
		<div className="no_data_found taCenter">
			<div className="icon"></div>
			<h2 className="err_msg">{props.errMsg ? props.errMsg : "No results found"}</h2>
			{(props.showClrBtn === undefined || props.showClrBtn === true) && (
				<EdButton value="Clear filters" btnTyp="blue-link" onClick={() => props.callBackMeth(props.data)} />
			)}
		</div>
	);
};

export default TocNoData;
